module.exports = __webpack_public_path__ + "img/ics_o_edit_dash_black.daeccb39.svg";